module.exports = __webpack_public_path__ + "media/marketing_campaigns/channels-41023b32.svg";